import { render, staticRenderFns } from "./select-option-group.vue?vue&type=template&id=70d3dae4&"
import script from "./select-option-group.vue?vue&type=script&lang=js&"
export * from "./select-option-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports